/// <amd-module name="VSS/Redux/Modules/QueuedActions/QueuedActionsSaga" />
import { AnyAction } from "redux";
import { Channel, channel, effects, SagaIterator } from "redux-saga";

export function* queuedActionsRootSaga() {
    // Always start a new queue whenever the module is mounted
    // We will NOT mark any document dirty here so if the module is unmounted all the queued messages will be lost
    queue = (yield effects.call(channel)) as any;
    yield effects.fork(monitorQueue);
}

const IsCompletedMetaType = "isCompletedCounter";
let queue: Channel<any>;
let completedActionPattern: { [id: number]: effects.ActionPattern } = {};
let counter: number = 0;

/**
 * Queues actions for serial processing
 * @param action Action to queue
 * @param isCompleted Optional, if provided the next actions are not processed until the saga receives an action matching this pattern
 */
export function* queueAction(action: AnyAction, isCompleted?: effects.ActionPattern): SagaIterator {
    if (isCompleted) {
        counter++;
        completedActionPattern[counter] = isCompleted;
        if (!action.meta) {
            action.meta = {};
        }
        action.meta[IsCompletedMetaType] = counter;
    }
    yield effects.put(queue, action);
}

function* monitorQueue() {
    while (true) {
        const message = (yield effects.take(queue)) as any;
        yield effects.put(message);
        if (message.meta && message.meta[IsCompletedMetaType]) {
            const patternId = message.meta[IsCompletedMetaType];
            const pattern = completedActionPattern[patternId];
            delete completedActionPattern[patternId];

            yield effects.take(pattern);
        }
    }
}
